module.exports = __webpack_public_path__ + "static/media/01.National Award-Devanna Kamath.ebb3b09d.JPG";